import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

export interface DeleteConversationTRPCInput {
  Id: string;
}

export const useDeleteConversationTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.conversation.delete.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.comment.commentsByConversationId.queryKey(),
        });
      },
    }),
  });

  return {
    deleteConversation: async (
      input: DeleteConversationTRPCInput
    ): Promise<{ Id: string }> => mutation.mutateAsync(input),
    loading: mutation.isPending,
    error: mutation.error,
  };
};
